import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as supportActions } from '../../../actions/supportActions';
import { DEFAULT_PAGE_SIZE, DATETIME_FORMAT, MOBILE_WINDOW_BREAKPOINT, supportTicketStatuses } from '../../../constants/constants';
import { DataTable } from 'primereact/datatable';
import { MultiSelect } from 'primereact/multiselect';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import Icon from '../../Common/Icon';
import Notification from '../../../components/Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import Moment from 'moment';
import AgentSupportDrawer from '../../Support/AgentTicketDrawer/AgentTicketDrawer';
import { createdFromNow } from '../../../helpers/dateTime';
import { getDataTableSortFields, getSearchParamSortFields } from '../../../helpers/sortHelper';

const statusOptions = [
	{ name: 'Open', id: supportTicketStatuses.Open },
	{ name: 'Pending', id: supportTicketStatuses.Pending },
	{ name: 'Solved', id: supportTicketStatuses.Solved },
];

export class SupportPage extends React.Component {
	constructor(props, context) {
		super(props, context);

		const supportTicket = {
			id: 0,
			agentId: 0,
			agentName: '',
			subject: '',
			status: 0,
			createdByName: '',
			createdDate: '',
		};

		this.state = {
			tickets: [],
			agents: [],
			selectedTicket: null,
			newTicket: supportTicket,
			editTicket: supportTicket,
			totalCount: 0,
			isFetching: false,
			drawerOpen: false,
			isFormValid: true,
			errorMessage: '',
			searchParams: {
				subscriptionId: this.props.subscriptionId,
				agentName: '',
				subject: '',
				requestorName: '',
				statuses: [statusOptions[0], statusOptions[1]],
				pageNumber: 1,
				pageSize: DEFAULT_PAGE_SIZE,
				sortBy: 'id',
				sortDir: 'asc',
			},
		};
		this.search.bind(this);
	}

	async componentDidMount() {
		document.title = 'Admin';
		await this.search();
		await this.loadFilters();
	}

	async search() {
		let statuses = [];
		if (this.state.searchParams.statuses.length > 0) {
			statuses = this.state.searchParams.statuses.map((item) => {
				return item.id;
			});
		}

		const params = {
			...this.state.searchParams,
			statuses: statuses,
		};

		try {
			this.setState({ isFetching: true });
			const result = await this.props.supportActions.searchTickets(params);
			const payload = result.payload;
			if (result.type === types.SEARCH_SUPPORT_TICKET_SUCCESS) {
				this.setState({ tickets: payload.results, totalCount: payload.totalCount });
			} else if (result.type === types.SEARCH_SUPPORT_TICKET_FAILURE) {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isFetching: false });
		}
	}

	async loadFilters() {
		try {
			this.setState({ isFetching: true });
			const result = await this.props.supportActions.loadListFilters(this.props.subscriptionId);
			const payload = result.payload;
			if (result.type === types.LOAD_SUPPORT_TICKET_FILTERS_SUCCESS) {
				this.setState({ agents: payload.agents });
			} else if (result.type === types.LOAD_SUPPORT_TICKET_FILTERS_FAILURE) {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isFetching: false });
		}
	}

	filterChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, [e.target.name]: e.target.value } });
	};

	keyUpName = (e) => {
		if (e.keyCode == 13) {
			this.search();
		}
	};

	onSearchBlur = () => {
		this.search();
	};

	onPageChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, pageNumber: e.page + 1 } }, () => {
			this.search();
		});
	};

	onChangeAgent = async (agentId) => {
		try {
			this.setState({ isFetching: true });
			const result = await this.props.supportActions.updateAgent(agentId, this.state.selectedTicket.id);
			const payload = result.payload;
			if (result.type === types.UPDATE_SUPPORT_TICKET_AGENT_SUCCESS) {
				Notification('success', 'Agent Reassigned Successfully', '');
				this.search();
			} else if (result.type === types.UPDATE_SUPPORT_TICKET_AGENT_FAILURE) {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isFetching: false });
		}
	};

	onStatusChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, statuses: e.value } }, () => {
			this.search();
		});
	};

	// ------- Drawer

	onDrawerComplete = () => {
		this.setState({ drawerOpen: false }, () => {
			this.search();
		});
	};

	selectTicket = (e) => {
		// if they're targeting the select box in the agent column then don't open the drawer
		const newValue = e.value || this.state.selectedTicket;
		this.setState({ selectedTicket: newValue, editTicket: newValue, drawerOpen: true, errorMessage: '', isFormValid: true });
	};
	// ------- Drawer

	agentTemplate = (rowData) => {
		const agentId = rowData.agentId ? rowData.agentId.toString() : '';
		return (
			<div>
				<MultiSelectBox
					className='agent-select'
					name='agentId'
					placeholder='Agent'
					idField='id'
					valueField='name'
					options={this.state.agents}
					selectedValues={agentId}
					onChange={this.onChangeAgent}
					isMulti={false}
				/>
			</div>
		);
	};

	statusTemplate = (rowData) => {
		let retval = '';
		switch (rowData.status) {
			case supportTicketStatuses.Open:
				retval = 'Open';
				break;
			case supportTicketStatuses.Pending:
				retval = 'Pending';
				break;
			case supportTicketStatuses.Solved:
				retval = 'Solved';
				break;
		}
		return retval;
	};

	createdDateTemplate = (rowData) => {
		return Moment(rowData.createdDate).format(DATETIME_FORMAT);
	};

	createdFromNowTemplate = (rowData) => {
		return createdFromNow(rowData.createdDate);
	};

	onSort = ({ sortField, sortOrder }) => {
		const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
		if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
			this.setState(
				{
					searchParams: {
						...this.state.searchParams,
						sortBy: sortBy,
						sortDir: sortDir,
					},
				},
				this.search
			);
		}
	};

	render() {
		const displayColumns = this.props.windowWidth < MOBILE_WINDOW_BREAKPOINT ? 'none' : '';

		const agentFilterElement = (
			<input
				name='agentName'
				type='text'
				className='p-inputtext'
				placeholder='Agent Name'
				size='50'
				onBlur={this.onSearchBlur}
				onChange={this.filterChange}
				onKeyUp={this.keyUpName}
				value={this.state.searchParams.agentName}
			/>
		);
		const subjectFilterElement = (
			<input
				name='subject'
				type='text'
				className='p-inputtext'
				placeholder='Subject'
				size='50'
				onBlur={this.onSearchBlur}
				onChange={this.filterChange}
				onKeyUp={this.keyUpName}
				value={this.state.searchParams.subject}
			/>
		);
		const requestorFilterElement = (
			<input
				name='requestorName'
				type='text'
				className='p-inputtext'
				placeholder='Requestor'
				size='50'
				onBlur={this.onSearchBlur}
				onChange={this.filterChange}
				onKeyUp={this.keyUpName}
				value={this.state.searchParams.requestorName}
			/>
		);
		const statusFilter = (
			<MultiSelect
				className='ui-column-filter'
				optionLabel='name'
				appendTo={document.body}
				value={this.state.searchParams.statuses}
				options={statusOptions}
				onChange={this.onStatusChange}
				maxSelectedLabels={1}
			/>
		);
		const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

		return (
			<div>
				{this.state.drawerOpen ? (
					<AgentSupportDrawer ticketId={this.state.selectedTicket.id.toString()} onComplete={this.onDrawerComplete} />
				) : (
					''
				)}
				<LoadingIndicator isLoading={this.state.isFetching} hideWhileLoading={true}>
					<div>
						<div className='identifier-header'>
							<div className='title'>Support Cases</div>
							<div className='close'>
								<button type='button' onClick={this.props.onClose} alt='close popup'>
									<Icon name='times' />
								</button>
							</div>
						</div>
						<br />
						<div className='identifier-results-table'>
							<DataTable
								filterDisplay='row'
								className='p-datatable-sm p-datatable-striped'
								value={this.state.tickets}
								selectionMode='single'
								selection={this.state.selectedTicket}
								onSelectionChange={this.selectTicket}
								sortField={sortField}
								sortOrder={sortOrder}
								onSort={this.onSort}>
								<Column
									field='agentName'
									header='Agent'
									filter={true}
									filterElement={agentFilterElement}
									body={this.agentTemplate}
									sortable={true}
								/>
								<Column
									field='subject'
									header='Subject'
									filter={true}
									filterElement={subjectFilterElement}
									style={{ display: displayColumns }}
									sortable={true}
								/>
								<Column
									field='createdByName'
									header='Requestor'
									filter={true}
									filterElement={requestorFilterElement}
									style={{ display: displayColumns }}
									sortable={true}
								/>
								<Column field='createdDate' header='Created' body={this.createdDateTemplate} sortable={true} />
								<Column
									field='createdFromNow'
									header='Time'
									body={this.createdFromNowTemplate}
									style={{ display: displayColumns }}
									sortable={true}
								/>
								<Column
									field='status'
									header='Status'
									body={this.statusTemplate}
									filter={true}
									filterElement={statusFilter}
									sortable={true}
								/>
							</DataTable>
							{this.state.totalCount > this.state.searchParams.pageSize && (
								<Paginator
									rows={this.state.searchParams.pageSize}
									totalRecords={this.state.totalCount}
									first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
									onPageChange={this.onPageChange}
								/>
							)}
							<div className='results-count'>Total records: {this.state.totalCount}</div>
						</div>
					</div>
				</LoadingIndicator>
			</div>
		);
	}
}

SupportPage.propTypes = {
	windowWidth: PropTypes.number,
	subscriptionId: PropTypes.number.isRequired,
	supportActions: PropTypes.object.isRequired,
	onClose: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
	return {
		supportActions: bindActionCreators(supportActions, dispatch),
	};
}

function mapStateToProps(state) {
	return {
		windowWidth: state.window.width,
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(SupportPage);
